import React, { memo } from "react";
import { Divider, DividerProps } from "@mui/material";

const CustomDivider = memo((props: DividerProps) => {
  return <Divider {...props} />;
});

export { CustomDivider };
